module.exports = __webpack_public_path__ + "BR.png?8e1d47b04cc0424ee45487e616f51d48";